import { Component } from '@angular/core';
import { Data, Router, RouterModule } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import { Alert } from 'src/app/shared/models/Alert';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ResponseDataFile } from 'src/app/shared/models/ApiResponse';
import { saveAs } from 'file-saver';
import { PaginationService } from 'src/app/shared/services/pagination.service';
import { InventoryService } from 'src/app/services/inventory.service';
import { DeviceDTO } from 'src/app/models/DeviceDTO.model';
import { PlanAvailableDTO } from 'src/app/models/PlanAvailableDTO.model';
import { LogCallbackDTO } from 'src/app/models/LogCallbackDTO.model';
import { TableColumn } from 'src/app/models/TableColumn';

import { InventoryCreateComponent } from '../inventory-create/inventory-create.component';
import { InventoryMassUpdateCreateComponent } from '../inventory-mass-update-create/inventory-mass-update-create.component';
import { TableControlComponent } from '../../../shared/controls/table-control/table-control.component';
import { DeviceApiLogsComponent } from '../../../shared/components/device-api-logs/device-api-logs.component';
import { renderDeviceStatus } from '../../../models/StatusSimDTO.model';
import { TooltipDirective } from '../../../directives/tooltip.directive';
declare var bootstrap: any;

@Component({
    selector: 'app-inventory-list',
    templateUrl: './inventory-list.component.html',
    styleUrl: './inventory-list.component.css',
    imports: [
        RouterModule,
        TooltipDirective,
        InventoryCreateComponent,
        InventoryMassUpdateCreateComponent,
        TableControlComponent,
        DeviceApiLogsComponent
    ]
})
export class InventoryListComponent {
  selectedDevices: DeviceDTO[] = [] as DeviceDTO[];
  shouldClearSelection: boolean = false;

  sims: DeviceDTO[] = [] as DeviceDTO[];
  logsCallback: LogCallbackDTO[] = [] as LogCallbackDTO[];
  plansAvailables: PlanAvailableDTO[] = [] as PlanAvailableDTO[];
  originalPlansAvailables: PlanAvailableDTO[] = [] as PlanAvailableDTO[];
  filteredSims: DeviceDTO[] = [] as DeviceDTO[];
  filteredLogs: LogCallbackDTO[] = [] as LogCallbackDTO[];
  filteredSimsAvailables: DeviceDTO[] = [] as DeviceDTO[];
  textoBusqueda: string = '';
  textoBusquedaLogs: string = '';
  textoBusquedaTransferSim: string = '';
  isAnyCheckBoxInventory: boolean = false;
  totalPagesPlansAvailables: number = 0;
  totalPagesLogs: number = 0;
  recordsPerPage: number = 10;
  currentPageAvailables: number = 1;
  currentPageLogs: number = 1;
  pagesToShowAvailables: number = 5;
  pagesToShowLogs: number = 5;
  chekedItemsCount: number = 0;

  modalAlertTransferBody: string = `Are you sure you want to transfer ${this.chekedItemsCount} devices?`;

  isCheckAllChecked: boolean = false;

  public isArhivedMode = false;
  public toggleArhivedMode() {
    this.isArhivedMode = !this.isArhivedMode;
    this.HandleGetListSims(this.originalSims);
  }

  columns: TableColumn[] = [
    {
      key: 'primaryDevice', header: 'Primary', format: {
        type: 'boolean',
        trueDisplay: 'True', 
        falseDisplay: 'False',
      }
    },
    { key: 'carrierName', header: 'Carrier' },
    { key: 'nameStatus', header: 'Status', cellClass: 'text-center', render: (v, r) => renderDeviceStatus(v, r) },
    { key: 'nameCustomer', header: 'Customer Assigned', width: 250 },
    { key: 'iccid', header: 'ICCID' },
    { key: 'imei', header: 'IMEI' },
    { key: 'mdn', header: 'MDN' },
    { key: 'modemType', header: 'Modem Type' },
    { key: 'serialNumber', header: 'Serial Number' },
    { key: 'ipAddress', header: 'Static IP' },
    { key: 'deviceName', header: 'Username' },
    { key: 'deviceName2', header: 'Username 2' },
    { key: 'custom1', header: 'Custom field 1' },
    { key: 'custom2', header: 'Custom field 2' },
    { key: 'zipCode', header: 'MDN Zip Code' },
    { key: 'nameRatePlan', header: 'Rate Plan', width: 250 },
    { key: 'idAssignedTo', header: 'Assigned to', width: 250 },
    { key: 'dateAssignedString', header: 'Date Assigned' },
    { key: 'costCode', header: 'Cost Code' },
    { key: 'firstName', header: 'First Name', width: 250 },
    { key: 'lastName', header: 'Last Name', width: 250 },
    { key: 'linkworxActivationDate', header: 'Linkworx - Activation Date', format: {
        type: 'date',
        dateFormat: 'MM/dd/yyyy',
      } },
    { key: 'carrierActivationDate', header: 'Carrier - Activation Date', format: {
        type: 'date',
        dateFormat: 'MM/dd/yyyy',
      } },
    { key: 'deactivationDate', header: 'Deactivation Date', format: {
        type: 'date',
        dateFormat: 'MM/dd/yyyy',
      }
    },
    { key: 'suspensionDate', header: 'Suspension Date', format: {
        type: 'date',
        dateFormat: 'MM/dd/yyyy',
      }
    },
    { key: 'originatedFrom', header: 'Originated From', width: 250 },
  
  ];

  actionButtons = [
    { label: 'viewLogs', class: 'secondary', icon: 'bi bi-clock-history', hidden: () => this.isArhivedMode, tooltip: 'View Logs' },
    { label: 'edit', class: 'primary', icon: 'bi bi-pencil', hidden: () => this.isArhivedMode, tooltip: 'Edit Device' },
    {
      label: 'archive',
      icon: 'bi bi-archive',
      class: () => this.isArhivedMode ? 'primary' : 'danger',
      tooltip: () => this.isArhivedMode ? 'Restore Device' : 'Archive Device'
    },

  ];

  isFilteredByStatus: boolean = false;
  originalSims: DeviceDTO[] = [] as DeviceDTO[];
  originalLogs: LogCallbackDTO[] = [] as LogCallbackDTO[];
  selectedSim: DeviceDTO = {} as DeviceDTO;
  alert: Alert = {} as Alert;
  showDeviceApiLogsModal: boolean = false;
  filteredData: DeviceDTO[] = [] as DeviceDTO[];

  constructor(
    private inventoryService: InventoryService,
    private router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService,
    public permissionsService: ValidatePermissionsService,
    public paginationService: PaginationService
  ) { }

  ngOnInit() {
    this.permissionsService.validateAccessLevels(MODULE_ID.Inventory);
    this.inventoryService.getListSims().subscribe(
      ({ StatusCode, Message, Data }) => {
        if (Data != null) {
          this.HandleGetListSims(Data);
        } else {
          this.HandleGetListError(StatusCode);
        }
      },
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000,
        };
        this.alertService.updateAlertState(this.alert);
      }
    );
  }

  onSelectionChange(selectedDevices: DeviceDTO[]): void {
    this.selectedDevices = selectedDevices;

  }

  onFilteredItemsChange(data: DeviceDTO[]): void {
//    debugger;

    this.filteredData = data;

  }

  onAction(event: { action: string; item: DeviceDTO }): void {

    switch (event.action) {
      case 'viewLogs':
        this.selectedSim = event.item;;
        this.showDeviceApiLogsModal = true;

        break;
      case 'edit':
        this.navigateToUpdateSim(event.item)
        break;
      case 'archive':
        const modalArchive = new bootstrap.Modal("#modalArchive");
        modalArchive.show();
        this.setArchivedSim(event.item)
        break;
    }
  }



  HandleGetListError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000,
    };
    this.alertService.updateAlertState(this.alert);
  }

  HandleGetListSims(simsList: DeviceDTO[]) {
    // Guarda la lista de sims original
    
    this.sims = simsList;
    this.originalSims = this.sims.slice();
    this.sims = this.originalSims.filter((sim) => this.isArhivedMode ? sim.deviceStatus === 2 : sim.deviceStatus !== 2);

  }

  setSelectedSim(sim: DeviceDTO) {
    this.selectedSim = sim;
  }

  setArchivedSim(sim: DeviceDTO) {
    this.selectedSim = sim;
    this.selectedSim.deviceStatus = this.isArhivedMode ? 0 : 2;
  }

  /*
  toggleStatus(event: any, sim: DeviceDTO) {
    debugger;
    sim.deviceStatus = event.target.checked ? 1 : 0;
    const indice = this.originalSims.findIndex(
      (simD) => simD.deviceId === sim.deviceId
    );
    if (indice !== -1) {
      this.originalSims[indice].deviceStatus = sim.deviceStatus;
    }
  }
  */

  openConfirmationModal(sim: DeviceDTO) {
    this.selectedSim = sim;
  }

  updateSimStatus(confirmed: boolean) {
    if (confirmed) {
      this.inventoryService.updateSimStatus(this.selectedSim).subscribe(
        ({ StatusCode, Message, Data }) => {
          if (Data != null) {
            this.HandleUpdateSimStatus(Data);
          } else {
            this.HandleUpdateSimStatusError(StatusCode);
          }
        },
        (error) => {
          this.alert = {
            alertMessage: 'Unexpected error. Please try again later.',
            alertType: 'alert alert-danger',
            alertCenter: false,
            alerTitle: '',
            duration: 3000,
          };
          this.alertService.updateAlertState(this.alert);
        }
      );
    } else {
      location.reload();
    }
  }

  async HandleUpdateSimStatus(customer: boolean) {
    this.alert = {
      alertMessage: 'Sim updated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000,
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(this.alert);
    location.reload();
  }

  HandleUpdateSimStatusError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000,
    };
    this.alertService.updateAlertState(this.alert);
  }

  async HandleUpdateSim(customer: boolean) {
    this.alert = {
      alertMessage: 'Sim updated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000,
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(this.alert);
    location.reload();
  }

  navigateToUpdateSim(sim: DeviceDTO) {
    console.log(sim);
    this.router.navigate(['/inventory/inventory-update/' + sim.iccid], {
      relativeTo: this.route,
      state: { simData: sim },
    });
  }

  goBack() {
    window.location.href = '/home';
  }

  navigateToCustomerView(customer: any) {
    this.router.navigate(['/customers/view-customer', customer.userId]);
  }

  exportInventoryListToExcel() {



    this.inventoryService.exportToExcelListOfInventory(this.filteredData).subscribe(
      (reponse) => {

        const byteCharacters = atob(reponse.fileContents);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: reponse.contentType });
        saveAs(blob, reponse.fileDownloadName || 'export.xlsx');

      },
      (error) => {
        this.alertService.error('Unexpected error. Please try again later.');
      }
    );

  }





  onDismiss(value: boolean) {
    this.showDeviceApiLogsModal = false;
  }
}
